import React, { Suspense } from 'react'
import { ApolloProvider } from '@apollo/client'
import BackOffice from './BackOffice'
import { notification } from 'antd'
import CentredLoader from './components/CentredLoader'
import { client } from './apollo/client'
import CurrentUserContextProvider from './contexts/currentUserContext'
import AbilityContextProvider from './contexts/abilityContext'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './i18n'

// WARN: router v6
const App = (): JSX.Element => {
  const [api, contextHolder] = notification.useNotification()

  return (
    <ApolloProvider client={client}>
      <CurrentUserContextProvider>
        <AbilityContextProvider>
          <Suspense fallback={<CentredLoader tip="Loading..." size="large" />}>
            <>
              {contextHolder}
              <BackOffice />
            </>
          </Suspense>
        </AbilityContextProvider>
      </CurrentUserContextProvider>
    </ApolloProvider>
  )
}

export default App
